/* eslint-disable no-unused-vars */
import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import SecurityIcon from '@mui/icons-material/Security';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import LockIcon from '@mui/icons-material/Lock';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import AssessmentIcon from '@mui/icons-material/Assessment';
import GppGoodIcon from '@mui/icons-material/GppGood';

const Trust = () => {
    const theme = useTheme();

    const trustItems = [
        {
            icon: <SecurityIcon sx={{ fontSize: 48 }} />,
            title: 'Enterprise Security',
            description: 'Enterprise-grade security infrastructure with end-to-end encryption and advanced threat protection.',
        },
        {
            icon: <VerifiedUserIcon sx={{ fontSize: 48 }} />,
            title: 'Compliance Ready',
            description: 'Solutions designed to meet GDPR, HIPAA, and FedRAMP requirements for regulated industries.',
        },
        {
            icon: <LockIcon sx={{ fontSize: 48 }} />,
            title: 'Data Protection',
            description: 'Comprehensive data governance with automated backups, disaster recovery, and audit trails.',
        },
        {
            icon: <CloudDoneIcon sx={{ fontSize: 48 }} />,
            title: 'Cloud Infrastructure',
            description: 'Expertise in AWS, Azure, and GCP with multi-region deployment capabilities.',
        },
        {
            icon: <AssessmentIcon sx={{ fontSize: 48 }} />,
            title: '24/7 Monitoring',
            description: 'Real-time monitoring, alerting, and incident response with guaranteed uptime SLAs.',
        },
        {
            icon: <GppGoodIcon sx={{ fontSize: 48 }} />,
            title: 'Expert Team',
            description: 'Experienced professionals with industry-recognized expertise and proven track records.',
        },
    ];

    return (
        <Box>
            <Box 
                marginBottom={5} 
                textAlign="center"
                sx={{
                    position: 'relative',
                }}
            >
                <Typography
                    data-aos="fade-up"
                    sx={{
                        textTransform: 'uppercase',
                        fontWeight: 700,
                        letterSpacing: '0.15em',
                        fontSize: '0.875rem',
                        color: theme.palette.primary.main,
                        marginBottom: 2,
                    }}
                >
                    Trust & Security
                </Typography>
                <Box
                    component={Typography}
                    fontWeight={900}
                    variant={'h2'}
                    gutterBottom
                    data-aos="fade-up"
                    data-aos-delay="100"
                    sx={{
                        fontSize: { xs: '2.5rem', md: '3.5rem' },
                        lineHeight: 1.1,
                        letterSpacing: '-0.02em',
                        position: 'relative',
                        display: 'inline-block',
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            bottom: '-15px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: '60px',
                            height: '4px',
                            background: theme.palette.primary.main,
                            borderRadius: '2px',
                        },
                    }}
                >
                    Enterprise-Grade Security & Compliance
                </Box>
                <Typography
                    variant={'h6'}
                    component={'p'}
                    color={'textSecondary'}
                    sx={{
                        maxWidth: '800px',
                        margin: '0 auto',
                        lineHeight: 1.7,
                    }}
                >
                    Your data security and compliance are our top priorities. We implement 
                    industry-leading security practices and design solutions to meet regulatory 
                    requirements for your mission-critical systems.
                </Typography>
            </Box>
            <Grid container spacing={4}>
                {trustItems.map((item, i) => (
                    <Grid item xs={12} sm={6} md={4} key={i}>
                        <Card
                            sx={{
                                height: '100%',
                                boxShadow: 2,
                                borderRadius: 3,
                                transition: 'all 0.3s ease-in-out',
                                '&:hover': {
                                    transform: 'translateY(-4px)',
                                    boxShadow: 6,
                                },
                            }}
                        >
                            <CardContent
                                sx={{
                                    padding: 4,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                <Box
                                    sx={{
                                        color: theme.palette.primary.main,
                                        marginBottom: 2,
                                    }}
                                >
                                    {item.icon}
                                </Box>
                                <Typography
                                    variant="h6"
                                    fontWeight={700}
                                    gutterBottom
                                >
                                    {item.title}
                                </Typography>
                                <Typography
                                    variant="body1"
                                    color="textSecondary"
                                    sx={{ lineHeight: 1.7 }}
                                >
                                    {item.description}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default Trust;

